import api from "./Api";
import { IUpload } from "../interfaces/IUpload";

class UploadService {
    async obterTodos(offset: number = 0, perPage: number = 10, tipo?: string): Promise<{ data: IUpload[], totalCount: number }> {
        const response = await api.get(`/upload`, {
            params: {
                offset,
                perPage,
                tipo
            }
        });
        return response.data;
    }

    async obterUrlDownload(id: number): Promise<string> {
        const { data } = await api.get<{ url: string }>(`/upload/download/${id}`);
        return data.url;
    }
}

export default new UploadService();
